import { z } from 'zod';
/** Emails are compared case-insensitively everywhere; normalise at the edge. */
export const Email = z.string().trim().toLowerCase().pipe(z.string().email().max(254));
export const Role = z.enum(['admin', 'prospect']);
export const MagicLinkBody = z.object({ email: Email });
/** The one-time token from a sign-in link (base64url of 32 random bytes). */
export const VerifyBody = z.object({ token: z.string().regex(/^[A-Za-z0-9_-]{43}$/) });
export const Me = z.object({
    email: z.string(),
    name: z.string().nullable(),
    role: Role,
    /** True until a prospect accepts the current TERMS_VERSION (admins: false). */
    needs_terms: z.boolean(),
});
export const AdminUser = z.object({
    id: z.string(),
    email: z.string(),
    name: z.string().nullable(),
    company: z.string().nullable(),
    role: Role,
    disabled: z.boolean(),
    created_at: z.string(),
    terms_version: z.string().nullable(),
    terms_accepted_at: z.string().nullable(),
    last_login_at: z.string().nullable(),
});
export const CreateUserBody = z.object({
    email: Email,
    name: z.string().trim().min(1).max(200).optional(),
    company: z.string().trim().min(1).max(200).optional(),
    role: Role.default('prospect'),
    /** Email the new user a sign-in link right away. */
    invite: z.boolean().default(true),
});
export const UpdateUserBody = z
    .object({
    name: z.string().trim().max(200).nullable(),
    company: z.string().trim().max(200).nullable(),
    role: Role,
    disabled: z.boolean(),
})
    .partial();
export const ActivityKind = z.enum(['login', 'terms_accept', 'search', 'download']);
export const ActivityEntry = z.object({
    id: z.string(),
    at: z.string(),
    user_id: z.string(),
    email: z.string(),
    kind: ActivityKind,
    detail: z.record(z.unknown()),
    ip: z.string().nullable(),
});
export const ActivityQuery = z.object({
    user_id: z.string().uuid().optional(),
    kind: ActivityKind.optional(),
    limit: z.coerce.number().int().min(1).max(1000).default(200),
});
//# sourceMappingURL=auth.js.map